<template>
    <div v-if="content" class="sosv-product-tree">
        <osv-product-tree :product-tree-id="parseInt(content.id)" />
    </div>
</template>
  
<script>
export default {
    props: {
        content: null
    },
    data() {
        return {};
    },
    created() {
    },
};
</script>
  
<style lang="scss">
.sosv-product-tree{
    max-width: 900px;
    width: 95%;
    margin: auto;
    margin-top: 50px;
}
  </style>
  